<div class="certification-view">
  <div class="modal-body">
    <img src="/assets/images/certification_big01.png" alt="ISO 45001" *ngIf="seq==1">
    <img src="/assets/images/certification_big02.png" alt="ISO 45001" *ngIf="seq==2">
    <img src="/assets/images/certification_big03.png" alt="ISO 9001" *ngIf="seq==3">
    <img src="/assets/images/certification_big04.png" alt="ISO 9001" *ngIf="seq==4">
    <img src="/assets/images/certification_big05.png" alt="ISO 14001" *ngIf="seq==5">
    <img src="/assets/images/certification_big06.png" alt="ISO 14001" *ngIf="seq==6">
    <img src="/assets/images/certification_big07.png" alt="특허증 (열교환 시스템)" *ngIf="seq==7">
    <img src="/assets/images/certification_big08.png" alt="특허증 (안전빨대,이의 제조장치 및 이의 제조방법)" *ngIf="seq==8">
    <img src="/assets/images/certification_big09.png" alt="특허증 (엘리베이터 냉방 시스템)" *ngIf="seq==9">
    <img src="/assets/images/certification_big10.png" alt="특허증 (응축기 냉각시스템)" *ngIf="seq==10">
    <img src="/assets/images/certification_big11.png" alt="글로벌IP스타기업" *ngIf="seq==11">
    <img src="/assets/images/certification_big12.png" alt="글로벌IP스타기업" *ngIf="seq==12">
    <img src="/assets/images/certification_big13.png" alt="생산성경영체제 확인서" *ngIf="seq==13">
    <img src="/assets/images/certification_big14.png" alt="위험성평가 인정서" *ngIf="seq==14">
    <img src="/assets/images/certification_big15.png" alt="원산지인증수출자 인증서" *ngIf="seq==15">
    <img src="/assets/images/certification_big16.png" alt="한국냉매관리기술협회   EPA" *ngIf="seq==16">
    <img src="/assets/images/certification_big17.png" alt="경영혁신형 중소기업(Main-Biz)확인서" *ngIf="seq==17">
    <img src="/assets/images/certification_big18.png" alt="이노비즈 확인서" *ngIf="seq==18">
    <img src="/assets/images/certification_big19.png" alt="Avena상표등록증" *ngIf="seq==19">
    <img src="/assets/images/certification_big20.png" alt="경쟁입찰참가자격등록증" *ngIf="seq==20">
    <img src="/assets/images/certification_big21.png" alt="가족친화인증서" *ngIf="seq==21">
    <img src="/assets/images/certification_big22.png" alt="기업부설연구소" *ngIf="seq==22">
    <img src="/assets/images/certification_big23.png" alt="냉매회수업" *ngIf="seq==23">
    <img src="/assets/images/certification_big24.png" alt="냉동기제조등록증" *ngIf="seq==24">
  </div>
  
  <div class="modal-footer">
    <button class="close-btn" (click)="activeModal.dismiss()">닫기</button>  
  </div>
</div>
